var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7705 12C20.7705 11.641 20.5765 11.406 20.1885 10.934C18.7685 9.21 15.6365 6 12.0005 6C8.36447 6 5.23247 9.21 3.81247 10.934C3.42447 11.406 3.23047 11.641 3.23047 12C3.23047 12.359 3.42447 12.594 3.81247 13.066C5.23247 14.79 8.36447 18 12.0005 18C15.6365 18 18.7685 14.79 20.1885 13.066C20.5765 12.594 20.7705 12.359 20.7705 12ZM12.0005 15C12.7961 15 13.5592 14.6839 14.1218 14.1213C14.6844 13.5587 15.0005 12.7956 15.0005 12C15.0005 11.2044 14.6844 10.4413 14.1218 9.87868C13.5592 9.31607 12.7961 9 12.0005 9C11.2048 9 10.4418 9.31607 9.87915 9.87868C9.31654 10.4413 9.00047 11.2044 9.00047 12C9.00047 12.7956 9.31654 13.5587 9.87915 14.1213C10.4418 14.6839 11.2048 15 12.0005 15Z",
    fill: "#274137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon2);
export default __webpack_public_path__ + "static/media/view_icon2.d06d8000fa01fc967f7fb2e7ae79b241.svg";
export { ForwardRef as ReactComponent };